import {
  Box,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { Close, DragIndicator } from "@mui/icons-material";
import { NoteItem, useWorkspaceStore } from "../../store/useWorkspaceStore";
import dayjs from "dayjs";
import { DraggableProvidedDragHandleProps } from "@hello-pangea/dnd";

type Props = {
  item: NoteItem;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
};

export const WorkspaceNoteCard = ({ item, dragHandleProps }: Props) => {
  const { removeItem } = useWorkspaceStore();

  return (
    <Card variant="outlined" sx={{ mb: 1.5, bgcolor: "action.hover" }}>
      <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
        <Box display="flex" alignItems="flex-start" gap={0.5}>
          <Box
            {...dragHandleProps}
            sx={{
              color: "text.disabled",
              cursor: "grab",
              mt: 0.25,
              flexShrink: 0,
            }}
          >
            <DragIndicator fontSize="small" />
          </Box>

          <Typography
            variant="body2"
            sx={{
              flexGrow: 1,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {item.text}
          </Typography>

          <Tooltip title="Sil">
            <IconButton
              size="small"
              color="error"
              onClick={() => removeItem(item.uid)}
              sx={{ flexShrink: 0 }}
            >
              <Close fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Box>

        <Typography
          variant="caption"
          color="text.disabled"
          display="block"
          mt={0.5}
          ml={3.5}
        >
          {dayjs(item.createdAt).format("DD.MM HH:mm")}
        </Typography>
      </CardContent>
    </Card>
  );
};
